import { gql, useLazyQuery } from "@apollo/client";
import { UserRole, WorkerType } from "../generated/graphql";

// 백엔드 ListStaffUserInput은 PaginationInput(page, row)만 확장하므로 그대로 맞춘다.
// (아직 codegen을 다시 돌리지 못해 generated/graphql.ts에는 이 오퍼레이션이 없어서
// 여기서 직접 타입을 선언한다. 다른 staff-user 훅들도 동일한 이유로 로컬 타입을 쓴다.)
export interface ListStaffUserInput {
  page?: number;
  row?: number;
}

export interface ListStaffUserLinkService {
  id: number;
  name: string;
}

export interface ListStaffUser {
  id: number;
  username?: string | null;
  name?: string | null;
  phone?: string | null;
  role: UserRole;
  workerType?: WorkerType | null;
  linkServices?: ListStaffUserLinkService[] | null;
}

export interface ListStaffUserOutput {
  ok: boolean;
  err?: string | null;
  totalPages?: number | null;
  totalResults?: number | null;
  users?: ListStaffUser[] | null;
}

export interface ListStaffUserQuery {
  listStaffUser: ListStaffUserOutput;
}

export interface ListStaffUserQueryVariables {
  input: ListStaffUserInput;
}

const LIST_STAFF_USER_QUERY = gql`
  query listStaffUser($input: ListStaffUserInput!) {
    listStaffUser(input: $input) {
      ok
      err
      totalPages
      totalResults
      users {
        id
        username
        name
        phone
        role
        workerType
        linkServices {
          id
          name
        }
      }
    }
  }
`;

export const useListStaffUser = (
  onCompleted?: (data: ListStaffUserQuery) => void
) => {
  return useLazyQuery<ListStaffUserQuery, ListStaffUserQueryVariables>(
    LIST_STAFF_USER_QUERY,
    {
      onCompleted,
      fetchPolicy: "network-only",
    }
  );
};
